import React from 'react';

const ElevatorIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="49px" height="64px" viewBox="0 0 49 64" version="1.1">
      <g id="surface1">
        <path stroke={'none'} fill={'currentColor'} d="M 24.285156 0 L 0 24.109375 L 48.570312 24.109375 Z M 0 40.179688 L 24.285156 64.285156 L 48.570312 40.179688 Z M 0 40.179688 "/>
      </g>
    </svg>
  );
};

export default ElevatorIcon;
